import { render, staticRenderFns } from "./SnoozeSelector.vue?vue&type=template&id=61868f35&"
import script from "./SnoozeSelector.vue?vue&type=script&lang=js&"
export * from "./SnoozeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports